'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DESide = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _core = require('@blueprintjs/core');

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NarrowDialog = (0, _glamorous2.default)(_core.Dialog)({
  backgroundColor: _.Colors.WHITE1
});

var NarrowSide = function NarrowSide(_ref) {
  var children = _ref.children,
      ActionElement = _ref.ActionElement,
      onChangeIsOpen = _ref.onChangeIsOpen,
      isOpen = _ref.isOpen,
      actionLabel = _ref.actionLabel,
      titleLabel = _ref.titleLabel;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(ActionElement, { handler: onChangeIsOpen, actionLabel: actionLabel }),
    _react2.default.createElement(
      NarrowDialog,
      {
        iconName: 'filter-list',
        isOpen: isOpen,
        onClose: onChangeIsOpen,
        title: titleLabel
      },
      _react2.default.createElement(
        'div',
        { className: _core.Classes.DIALOG_BODY },
        children
      )
    )
  );
};

NarrowSide.propTypes = {
  children: _propTypes2.default.node,
  ActionElement: _propTypes2.default.func,
  actionLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  titleLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  isOpen: _propTypes2.default.bool,
  onChangeIsOpen: _propTypes2.default.func.isRequired
};

var Action = (0, _glamorous2.default)(_core.Button)({
  margin: '10px 0'
});

var NarrowAction = function NarrowAction(_ref2) {
  var actionLabel = _ref2.actionLabel,
      handler = _ref2.handler;
  return _react2.default.createElement(
    Action,
    {
      className: (0, _classnames2.default)(_core.Classes.MINIMAL, _core.Classes.FILL),
      iconName: 'filter-list',
      onClick: handler
    },
    actionLabel
  );
};

NarrowAction.propTypes = {
  actionLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  handler: _propTypes2.default.func
};

var DESide = exports.DESide = function DESide(_ref3) {
  var isNarrow = _ref3.isNarrow,
      children = _ref3.children,
      actionLabel = _ref3.actionLabel,
      titleLabel = _ref3.titleLabel;

  if (!isNarrow) return children;

  var DENarrowSide = (0, _.withCollapse)()(NarrowSide);
  return _react2.default.createElement(
    DENarrowSide,
    {
      actionLabel: actionLabel,
      ActionElement: NarrowAction,
      titleLabel: titleLabel
    },
    children
  );
};

DESide.propTypes = {
  isNarrow: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  actionLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  titleLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-side/index.js
// module id = 2026
// module chunks = 0